import React from "react";
import { ThreeDots } from "react-loader-spinner";

const SaveLoader = () => (
  <div style={{
    position: "fixed", inset: 0,
    background: "rgba(255,255,255,0.85)",
    display: "flex", flexDirection: "column",
    alignItems: "center", justifyContent: "center",
    zIndex: 9999, gap: "16px"
  }}>
    <ThreeDots
      visible={true}
      height="80"
      width="80"
      color="#4fa94d"
      radius="9"
      ariaLabel="three-dots-loading"
    />
    <p style={{ fontSize: "1rem", color: "#64748b", fontWeight: 500 }}>
      Enregistrement en cours...
    </p>
  </div>
);

export default SaveLoader;